import moment from 'moment'

/**
 * Period query params for the licence-plate search (`admin/search`,
 * `merchants/search/:merchantId`).
 *
 * The backend requires both timestamps or neither, and when they are omitted it
 * silently searches only the current month. So "All time" (no period chosen)
 * has to be sent as an explicit range from the epoch to the end of today.
 *
 * @param {String|null} startDate DD.MM.YYYY, or null for all time
 * @param {String|null} endDate DD.MM.YYYY, or null for all time
 */
const periodParams = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return {
      start_timestamp: 0,
      end_timestamp: moment().endOf('day').unix()
    }
  }
  return {
    start_timestamp: moment(startDate, 'DD.MM.YYYY').startOf('day').unix(),
    end_timestamp: moment(endDate, 'DD.MM.YYYY').endOf('day').unix()
  }
}

/**
 * The search endpoint answers "no parkings for this plate" with a 404 error
 * ("Parkings aren't found for license plate '…'") instead of an empty list.
 */
const isNoParkingsFoundError = (error) =>
  /parkings aren't found/i.test(error?.message || '')

/**
 * The backend returns a `next_id` whenever a page is full (100 rows), even
 * when nothing follows. Asking for that empty page fails: merchant-service
 * calls product-service with an empty `parking_ids=` and returns a 400 —
 * which really means "no more results".
 */
const isEmptyPageError = (error) =>
  /parking_ids=`/.test(error?.message || '')

export default {
  periodParams,
  isNoParkingsFoundError,
  isEmptyPageError
}
